import commoncss from '../css/common.module.css';
import buttoncss from "../css/button.module.css";

import { MdKeyboardArrowLeft } from "react-icons/md";
import { IoClose, IoChevronDown } from "react-icons/io5";
import filterIcon from "../assets/icons/filterone.svg";
import styles from "./Button.module.css";


export function Button({ class_="" , label, icon,btnColor, isEnabled=true,onClick, type="button", ...rest }) {
  
  return (
    <button type={type} className={`${buttoncss.custom_btn} ${btnColor === buttoncss.secondary ? buttoncss.secondary : btnColor}  ${isEnabled === true ? 'clickable' : commoncss.cursorNA} ${class_} `} disabled={!isEnabled} onClick={onClick} {...rest}>
      {icon && (icon)} {label}
    </button>
  );
}

export function FilterButton({ class_="" ,active, label, icon,btnColor="", isEnabled=true,onClick, ...rest }) {
  return (
    <button className={`${buttoncss.custom_btn} ${active ? buttoncss.filterBtnActive : buttoncss.filterBtnInactive} ${class_} ${isEnabled === true ? 'clickable' : ''}`} disabled={!isEnabled} onClick={onClick} {...rest}>
      {icon && (icon)} {label}
    </button>
  );
}

export function TableButton({ class_="" ,active, label, icon,btnColor="", isEnabled=true,onClick, ...rest }) {
  return (
    <button className={`${class_} ${buttoncss.custom_btn} ${buttoncss.tableButton} ${commoncss.w100} ${active ? buttoncss.tableButton : buttoncss.filterBtnInactive}  ${isEnabled === true ? 'clickable' : ''}`} disabled={!isEnabled} onClick={onClick} {...rest}>
      {icon && (icon)} {label}
    </button>
  );
}


export function IconButton({ class_="" , label, icon,btnColor, isEnabled=true,onClick, ...rest }) {
  return (
    <button className={`${class_} ${buttoncss.custom_btn} ${btnColor === buttoncss.secondary ? buttoncss.secondary : btnColor} ${buttoncss.buttonIcon}  ${isEnabled === true ? 'clickable' : ''}`} disabled={!isEnabled} onClick={onClick} {...rest}>
      <span className={buttoncss.iconSpan}>{icon && (icon)}</span><span className={commoncss.labelBlack}>{label}</span>
    </button>
  );
}

export function AddButton({ onClick, isEnabled = true }) {
  return (
    <button
      type="button"
      className={`${styles.baseButton} ${styles.primary} ${styles.addButton}`}
      disabled={!isEnabled}
      onClick={onClick}
    >
      Add
    </button>
  );
}

export function CancelButton({ onClick, isEnabled = true }) {
  return (
    <button
      type="button"
      className={`${styles.baseButton} ${styles.secondary} ${styles.cancelButton}`}
      disabled={!isEnabled}
      onClick={onClick}
    >
      Cancel
    </button>
  );
}

export function ContinueButton({ onClick, isEnabled = true }) {
  return (
    <button
      type="submit"
      className={`${styles.baseButton} ${styles.primary} ${styles.continueButton}`}
      disabled={!isEnabled}
      onClick={onClick}
    >
      Continue
    </button>
  );
}

export function ProceedButton({ onClick, isEnabled = true }) {
  return (
    <button
      type="button"
      className={`${styles.baseButton} ${styles.primary} ${styles.proceedButton}`}
      disabled={!isEnabled}
      onClick={onClick}
    >
      Proceed
    </button>
  );
}

export function SubmitMapButton({ onClick, isEnabled = true }) {
  return (
    <button
      type="button"
      className={`${styles.baseButton} ${styles.primary} ${styles.submapButton}`}
      disabled={!isEnabled}
      onClick={onClick}
    >
      Submit Mapping
    </button>
  );
}

export const BackArrowButton = ({ onClick, className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${styles.backArrow} ${className}`}
  >
    <MdKeyboardArrowLeft />
  </button>
);

export const CloseButton = ({ onClick, className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${styles.closeButton} ${className}`}
  >
    <IoClose />
  </button>
);

export const DropdownIcon = ({ onClick, className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${styles.dropdownButton} ${className}`}
  >
    <IoChevronDown />
  </button>
);

export const FilterIcon = ({ onClick, className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    className={`${styles.filterButton} ${className}`}
  >
    <img src={filterIcon} alt="Filter" />
  </button>
);
